import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './Button.module.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  variant?: 'solid' | 'soft';
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
}

const Button = ({
  label,
  variant = 'solid',
  icon,
  iconPosition = 'left',
  ...props
}: ButtonProps): JSX.Element => {
  return (
    <button
      {...props}
      className={classNames(styles.button, {
        [styles.solid]: variant === 'solid' || !variant,
        [styles.soft]: variant === 'soft',
      })}
    >
      {icon && iconPosition === 'left' && (
        <span className={styles.icon}>{icon}</span>
      )}
      <span>{label}</span>
      {icon && iconPosition === 'right' && (
        <span className={styles.icon}>{icon}</span>
      )}
    </button>
  );
};
export default Button;
